import React, { useEffect, useReducer} from 'react';
import {Container, Row,Button, Nav} from 'react-bootstrap'
import { Link } from 'react-router-dom';
import Footer from './Footer';
import Header from './Header';
import "../stylesheets/style.css"
import "../js/main.js"

const Career = () => {
    useEffect(() =>{
        document.title = "Career | Rich-Oak Group"
    },[])

    return (
      
      <div>





<div className="homepageslider" id="homepageslider">
<Header/>
{/* <Container className=''> */}


<div  id="careerfirstbox">
    <Row >
    <div className="col-lg-7 col-md-12">
        <div className='hmfirstinnerbox'>
        <h3 className="hmfirstboxheading">Career</h3>
        <p className='description hmfirstboxdescription'>
        We are a people driven by commitment to our work, with a<br/> great alignment of values, working with high integrity and for<br/> the achievement of our collective goals. We are passionate,<br/> independent thinkers and very consistent people.

        
        </p>
        
        {/* <p class="centermobile">
        <button className='hmfirstboxbutton hmbuttons'>LEARN MORE</button>
        <h4 className="hmbuttons hmvot">View our team <img src="images/arrow_forward.png"/></h4>
        </p> */}

  
        </div>
    </div>
    </Row>
    </div>



    <div className='hmsecondbox'>

    </div>

{/* 
    <div className='hmthirdbox hideipad'>
    <div className=''>
            <Row>
                <div className='col-md-12'>
                <img style={{width:"100%"}} src="images/careervideo.png"/> 
                    </div>
  
            </Row>
        </div>
    </div> */}




    <div className='hmfourthbox '>


            <Row class="blogmobile">
                <div className='col-lg-5 col-md-12'>
        <p className='hmcia'>Life at
       <span style={{color:"#D80032"}} > Rich-Oak </span> 
        
        </p>
     

        {/* <p className='hmcia formobileonly'>C
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p> */}
        <p  className="hmwwdp"></p>
        <p  className='hmfourthboxinner'>
        “No one comes to Rich-Oak and leaves the same, the company culture emphasizes training and development to push all staff to grow no matter what position you hold, from the highest to the lowest, learning and personal development is highly encouraged and the company provides us with the resources to pursue this".
                            </p>
        {/* <img style={{width:"100%"}} src="images/whatwedo.png"/>  */}
                    </div>
                    <div className='col-md-1'></div>

                    <div className='col-lg-5 col-md-12'>
                  
                       {/* <img class="img-fluid" src="images/credit.png"/> */}
                       <div class="divinvestments">
                        <p className="hmciahead">Trainings/Personal Develpment</p>
                        <p  className='hmfourthboxinner'>
                        Our people are empowered to learn and develop into their roles and within any department at Rich-Oak. We have a strong personnel development culture and are happy to support our people to grow.
                        
                            </p>
                            </div>

                            <div class="divinvestments2">
                            <p className="hmciahead">Diversity & Inclusion</p>
                        <p  className='hmfourthboxinner'>
                        Anyone with passion for what we do and the unique skills required for an available role can apply and work at Rich Oak. We give fair and equal opportunity to every candidate and every staff.                            </p>
                            </div>

                            <div class="divinvestments3">
                            <p className="hmciahead">Benefits</p>
                        <p  className='hmfourthboxinner'>
                        We want our people to excel in all aspects of their lives and that’s why we offer very competitive compensation and benefits which include – Health Insurance, Continuous personal development fund, Housing allowance, Paid time off, daily lunch plans and other perks aimed at boosting employee morale and rewarding good performance.                            </p>
                            </div>

                            <div class="divinvestments3">
                            <p className="hmciahead">Healthy Work enviroment</p>
                        <p  className='hmfourthboxinner'>
                        100% of our staff report that our work culture has helped them grow personally and professionally, positively impacted their lives and offers them job satisfaction.
                        </p>
                                                    </div>
                    </div>

        

                 
               
               
                
            </Row>

           
   
 
    </div> 

    <div class="hmfourthbox">
    <Row class="blogmobile">
                <div className='col-lg-5 col-md-12'>
        <p className='hmcia'>We want to
       <span style={{color:"#D80032"}} > hear </span> from you
        
        </p>
     

        {/* <p className='hmcia formobileonly'>C
       <span style={{color:"#D80032"}} > Investment</span> <br/>
        Allocation
        </p> */}
        <p  className="hmwwdp"></p>
        <p  className='hmfourthboxinner'>
        Our people mean everything to us, we want to become Africa’s most reliable financial partner and we know how the right people can make this Vision possible. We are looking to invest In people who bring strong skills, commitment and excellence to their jobs, people who can take ownership of their roles and contribute positively to the company’s vision and to team growth.                        
                            </p>
        {/* <img style={{width:"100%"}} src="images/whatwedo.png"/>  */}
                    </div>
                    <div className='col-md-1'></div>

                    <div className='col-lg-5 col-md-12'>
                  
                       {/* <img class="img-fluid" src="images/credit.png"/> */}
                       {/* <div class="divinvestments">
                        <p className="hmciahead">Interns and <br/> Graduates</p>
                        <p  className='hmfourthboxinner'>
                    Explore opportunities
                        <span><img style={{float:"right"}} src="./images/arrow_forward.png"/></span>
                            </p>
                            </div> */}

                            <div class="divinvestments2">
                            <p className="hmciahead">Experienced<br/> Professionals</p>
                        <p  className='hmfourthboxinner'>
                      Explore oppotunities 
                      <span><img style={{float:"right"}} src="./images/arrow_forward.png"/></span>

                                               </p>
                            </div>

                          
                    </div>

        

                 
               
               
                
            </Row>
    </div>






<br/>
<br/>


    </div>

<div id="homepagethirdbox">
    

</div>






    <Footer/>
    </div>


    )
    
    
}


export {Career as default}